import { LocalesEnum } from "~/types/entities";

interface IQuantitativeValueScheme {
  "@type": string;
  value: number;
}

interface IPostalAddressScheme {
  "@type": string;
  streetAddress: string;
  addressLocality: string;
  postalCode: string;
  addressCountry: string;
}

interface IOrganizationScheme {
  "@context": string;
  "@type": string;
  name: string;
  legalName: string;
  logo: string;
  sameAs: string[];
  url: string;
  telephone: string;
  numberOfEmployees: IQuantitativeValueScheme;
  email: string;
  description: string;
  address: IPostalAddressScheme[];
}

type TOrganizationScheme = {
  [key: string]: IOrganizationScheme;
};

const getOrganizationScheme = (): IOrganizationScheme => {
  const {
    public: { brandWithCapitalizeFirstLetter, siteUrl },
  } = useRuntimeConfig();
  const { locale } = useI18n();

  const OrganizationScheme: TOrganizationScheme = {
    [LocalesEnum["ru-by"]]: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: brandWithCapitalizeFirstLetter,
      legalName: "ООО \"ОЛЛСПОРТС\"",
      logo: `${siteUrl}/image/og-image-allsports.png`,
      sameAs: [
        "https://www.facebook.com/AllSports-355760931699171",
        "https://www.instagram.com/allsports.by/",
        "https://by.linkedin.com/company/allsportsby",
      ],
      url: siteUrl,
      telephone: "+375 44 525 38 92",
      numberOfEmployees: {
        "@type": "QuantitativeValue",
        value: 15,
      },
      email: "contact@allsports.by",
      description:
        "Первый агрегатор спортивных услуг в Беларуси. Allsports предлагает ежедневный доступ в тренажерные залы, центры йоги, бассейны, теннисные корты и многие другие спортивные услуги.",
      address: [
        {
          "@type": "PostalAddress",
          streetAddress:
            "г. Минск, ул. Интернациональная, 36-2, офисы 2-20, 1-21",
          addressLocality: "Minsk",
          postalCode: "220030",
          addressCountry: "BY",
        },
      ],
    },
  };

  return OrganizationScheme[locale.value];
};

export default getOrganizationScheme;
